import { isEqual } from 'lodash/lang';
import { union } from 'lodash/array';

function extractUnique(entries) {
    return entries.reduce((acc, [, item]) => {
        if (acc.length === 0) {
            return item;
        }
        if (!isEqual(acc, item)) {
            return union(acc, item);
        }
        return acc;
    }, []);
}

function areAllEqual(entries, unique) {
    return entries.reduce((acc, [, item]) => {
        if (acc === false) {
            return false;
        }

        return isEqual(unique, item);
    }, true);
}

function extractErrors(errors, keysCount) {
    const entries = Object.entries(errors);
    if (entries.length < keysCount) {
        return errors;
    }

    const reduced = extractUnique(entries);
    const allEqual = areAllEqual(entries, reduced);

    return allEqual ? reduced : errors;
}

export default extractErrors;
